export enum StepKind {
  Features = 'Features',
  Style = 'Style',
}
